import ImageObject from '@/docs-partials/api/schema/image-object.mdx';
import * as React from 'react';
export default {
  ImageObject,
  React
};